import { render, staticRenderFns } from "./ModalJoinPvp.vue?vue&type=template&id=7482bbf0&scoped=true"
import script from "./ModalJoinPvp.vue?vue&type=script&lang=js"
export * from "./ModalJoinPvp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7482bbf0",
  null
  
)

export default component.exports